module.exports = __webpack_public_path__ + "img/story029.34ae72b1.webp";